// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #66D2CE;
    --secondary: #2DAA9E;
    --light: #EAEAEA;
    --beige: #E3D2C3;
    --white: #FFFFFF;
    --black: #000000;
    --error: #EF4444;
}

/* Base Styles */
.poster-generator {
    min-height: 100vh;
    background: white;
    padding: 3rem 1rem;
}

.container {
    max-width: 56rem;
    margin: 0 auto;
}

/* Form Container */
.form-container {
    background: var(--light);
    border-radius: 2rem;
    padding: 2rem;
    margin-bottom: 2rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;
}

.form-container:hover {
    box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.3);
}

.form-title {
    font-size: 2.25rem;
    color: var(--secondary);
    text-align: center;
    margin-bottom: 2rem;
    font-weight: 700;
}

/* Form Elements */
.form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.form-group {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form-label {
    display: block;
    font-size: 1.125rem;
    color: #374151;
    margin-bottom: 0.5rem;
    font-weight: 500;
    align-self: flex-start;
}

.form-input {
    width: 90%;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    background: var(--white);
    border: 2px solid var(--beige);
    transition: all 0.3s ease;
    font-size: 1rem;
    color: #374151;
    margin-left: auto;
    margin-right: auto;
}

.form-input:focus {
    border-color: var(--secondary);
    outline: none;
    box-shadow: 0 0 0 2px rgba(102, 210, 206, 0.5);
}

.textarea {
    height: 8rem;
    resize: vertical;
}

/* Advanced Options Section */
.advanced-options {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}

.advanced-options-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    padding: 0.5rem 0;
    color: var(--light);
    font-size: 1.125rem;
    font-weight: 500;
}

.advanced-options-header:hover {
    color: var(--secondary);
}

.triangle-icon {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid var(--light);
    transition: transform 0.3s ease;
}

.advanced-options-header:hover .triangle-icon {
    border-top-color: var(--secondary);
}

.advanced-options-header.open .triangle-icon {
    transform: rotate(180deg);
}

.advanced-options-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

.advanced-options-content.open {
    max-height: 200px; /* Adjust based on content size */
}

/* GenAI Model Selector */
.genai-model-selector {
    margin-top: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%; /* Full width within advanced-options */
}

.genai-model-selector .form-label {
    font-size: 1.125rem;
    color: #374151;
    font-weight: 500;
    align-self: flex-start;
}

.genai-model-selector .form-input {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    border-radius: 0.5rem;
    background: var(--white);
    border: 2px solid var(--beige);
    transition: all 0.3s ease;
}

.genai-model-selector .form-input:focus {
    border-color: var(--secondary);
    outline: none;
    box-shadow: 0 0 0 2px rgba(102, 210, 206, 0.5);
}

/* Error Message */
.error-message {
    color: var(--error);
    font-weight: 500;
}

/* Submit Button */
.submit-btn {
    width: 100%;
    background: var(--secondary);
    color: var(--white);
    padding: 0.75rem 1.5rem;
    border-radius: 0.75rem;
    font-weight: 700;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
}

.submit-btn:hover {
    background: var(--primary);
    transform: scale(1.05);
}

.submit-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Results Section */
.results-container {
    background: var(--light);
    border-radius: 2rem;
    padding: 2rem;
    margin-top: 2rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.results-title {
    font-size: 1.875rem;
    color: var(--secondary);
    margin-bottom: 1.5rem;
    font-weight: 700;
}

/* Image Grid */
.image-grid {
    display: grid;
    gap: 1.5rem;
}

.image-item {
    position: relative;
    overflow: hidden;
    border-radius: 0.75rem;
    border: 2px solid var(--beige);
    transition: all 0.3s ease;
}

.image-item:hover {
    transform: scale(1.05);
}

.image {
    width: 100%;
    height: 12rem;
    object-fit: cover;
}

/* Loading Overlay */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.loading-spinner {
    width: 4rem;
    height: 4rem;
    border: 4px solid var(--secondary);
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive Design */
@media (min-width: 768px) {
    .image-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1024px) {
    .image-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/PosterGenerator.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB,EAAE,iCAAiC;AACxD;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW,EAAE,uCAAuC;AACxD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8CAA8C;AAClD;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[":root {\n    --primary: #66D2CE;\n    --secondary: #2DAA9E;\n    --light: #EAEAEA;\n    --beige: #E3D2C3;\n    --white: #FFFFFF;\n    --black: #000000;\n    --error: #EF4444;\n}\n\n/* Base Styles */\n.poster-generator {\n    min-height: 100vh;\n    background: white;\n    padding: 3rem 1rem;\n}\n\n.container {\n    max-width: 56rem;\n    margin: 0 auto;\n}\n\n/* Form Container */\n.form-container {\n    background: var(--light);\n    border-radius: 2rem;\n    padding: 2rem;\n    margin-bottom: 2rem;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n    transition: all 0.3s ease;\n}\n\n.form-container:hover {\n    box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.3);\n}\n\n.form-title {\n    font-size: 2.25rem;\n    color: var(--secondary);\n    text-align: center;\n    margin-bottom: 2rem;\n    font-weight: 700;\n}\n\n/* Form Elements */\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.form-label {\n    display: block;\n    font-size: 1.125rem;\n    color: #374151;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    align-self: flex-start;\n}\n\n.form-input {\n    width: 90%;\n    padding: 0.75rem 1rem;\n    border-radius: 0.5rem;\n    background: var(--white);\n    border: 2px solid var(--beige);\n    transition: all 0.3s ease;\n    font-size: 1rem;\n    color: #374151;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.form-input:focus {\n    border-color: var(--secondary);\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(102, 210, 206, 0.5);\n}\n\n.textarea {\n    height: 8rem;\n    resize: vertical;\n}\n\n/* Advanced Options Section */\n.advanced-options {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.advanced-options-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    padding: 0.5rem 0;\n    color: var(--light);\n    font-size: 1.125rem;\n    font-weight: 500;\n}\n\n.advanced-options-header:hover {\n    color: var(--secondary);\n}\n\n.triangle-icon {\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid var(--light);\n    transition: transform 0.3s ease;\n}\n\n.advanced-options-header:hover .triangle-icon {\n    border-top-color: var(--secondary);\n}\n\n.advanced-options-header.open .triangle-icon {\n    transform: rotate(180deg);\n}\n\n.advanced-options-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n}\n\n.advanced-options-content.open {\n    max-height: 200px; /* Adjust based on content size */\n}\n\n/* GenAI Model Selector */\n.genai-model-selector {\n    margin-top: 0.75rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%; /* Full width within advanced-options */\n}\n\n.genai-model-selector .form-label {\n    font-size: 1.125rem;\n    color: #374151;\n    font-weight: 500;\n    align-self: flex-start;\n}\n\n.genai-model-selector .form-input {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    font-size: 1rem;\n    border-radius: 0.5rem;\n    background: var(--white);\n    border: 2px solid var(--beige);\n    transition: all 0.3s ease;\n}\n\n.genai-model-selector .form-input:focus {\n    border-color: var(--secondary);\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(102, 210, 206, 0.5);\n}\n\n/* Error Message */\n.error-message {\n    color: var(--error);\n    font-weight: 500;\n}\n\n/* Submit Button */\n.submit-btn {\n    width: 100%;\n    background: var(--secondary);\n    color: var(--white);\n    padding: 0.75rem 1.5rem;\n    border-radius: 0.75rem;\n    font-weight: 700;\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.submit-btn:hover {\n    background: var(--primary);\n    transform: scale(1.05);\n}\n\n.submit-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* Results Section */\n.results-container {\n    background: var(--light);\n    border-radius: 2rem;\n    padding: 2rem;\n    margin-top: 2rem;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.results-title {\n    font-size: 1.875rem;\n    color: var(--secondary);\n    margin-bottom: 1.5rem;\n    font-weight: 700;\n}\n\n/* Image Grid */\n.image-grid {\n    display: grid;\n    gap: 1.5rem;\n}\n\n.image-item {\n    position: relative;\n    overflow: hidden;\n    border-radius: 0.75rem;\n    border: 2px solid var(--beige);\n    transition: all 0.3s ease;\n}\n\n.image-item:hover {\n    transform: scale(1.05);\n}\n\n.image {\n    width: 100%;\n    height: 12rem;\n    object-fit: cover;\n}\n\n/* Loading Overlay */\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.loading-spinner {\n    width: 4rem;\n    height: 4rem;\n    border: 4px solid var(--secondary);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n    .image-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (min-width: 1024px) {\n    .image-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
